import { Places } from 'src/Models/Places';
import { Properties } from './Properties';
import { Questions } from './Questions';
import { LogicAction } from './Logical/Logical';
import { SurveyThemes } from './SurveyThemes';
export class Surveys {
    id_survey: number;
    title: string;
    description: string;
    thankyou_message: string;
    thankyou_message_neutral: string;
    thankyou_message_detractor: string;
    url_survey: string;
    url_photo: string;
    language: string;
    button_answer_url: string;
    active: boolean;
    fk_company: number;
    contacts: number;
    createdat: Date;
    updatedat: Date;
    deletedat?: any;
    fk_user_create: number;
    fk_user_update?: any;
    fk_user_delete?: any;
    color_button: any;
    questions?: Questions[];
    companies?: any;
    place?: Places;
    surveyResponses?: any;
    users?: any;
    message_whatsapp: string;
    message_sms: string;
    message_email: string;
    phone_detractor: string;
    fk_place: number;
    days_quarantine: number;
    flag_wizard: boolean;
    point: number;
    name: string;
    fk_referral_program: number;
    type_survey: number;
    fk_survey_sample: number;
    flag_progress: boolean;
    autoresponse_promoter: boolean;
    subject_email: string;
    type_contact_response: string;
    flag_anonymous: boolean;
    flag_reset_survey: boolean;
    time_reset: number | null;
    flag_without_propaganda: boolean;
    flag_nps_color: boolean;
    label_typesurvey: string;
    flag_view_tags: boolean;
    message_whatsapp_without_html: string;
    email_detractor: string;
    url_redirect_thanks: string | null;
    flag_redirect_thanks: boolean;
    time_redirect_thanks: number | null;
    questions_total: number;
    url_plugin : string
    show_limit_modal_plugin: number | null;
    time_show_plugin: number | null;
    flg_resend : boolean;
    days_resend_1 : number;
    hours_resend_1 : number;
    days_resend_2 : number;
    hours_resend_2 : number;
    
    flag_send_indicated: boolean;
    flag_indicated_neutrals: boolean;
    fk_program_send_indicated: number | null;

    backgroud_type : number;
    background_image : string;
    flg_always_anonymous: boolean;
    btn_anonymous: string;
    type_view: number;
    show_details_first_step: boolean;
    propertiesOBJ: Properties[] | null;
    propertiesAudienceOBJ: Properties[] | null;
    show_consentiment_extra: boolean | null;
    expired:boolean;
    propertiesAudience: any;
    logical_thank_you_message: string | LogicAction[]
    surveyTheme: SurveyThemes;
}